import React from 'react';
import { motion } from 'framer-motion';
export const Urgency = () => {
  return <section className="py-16 md:py-24 bg-brand-charcoal relative overflow-hidden" data-id="element-404">
      {/* Subtle background pattern/texture */}
      <div className="absolute inset-0 opacity-10 mix-blend-overlay" style={{
      backgroundImage: 'radial-gradient(circle at 2px 2px, white 1px, transparent 0)',
      backgroundSize: '24px 24px'
    }} data-id="element-405"></div>

      <div className="container mx-auto px-6 max-w-4xl relative z-10 text-center" data-id="element-406">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.8
      }} data-id="element-407">
          <h2 className="text-3xl md:text-4xl font-serif text-brand-blush mb-4 leading-snug" data-id="element-408">
            El mejor momento para empezar fue ayer.
            <br data-id="element-409" />
            <span className="italic text-brand-cream" data-id="element-410">
              El segundo mejor momento es ahora.
            </span>
          </h2>

          <div className="space-y-4 text-brand-blush/90 text-lg md:text-xl font-light mb-6" data-id="element-411">
            <p className="font-medium text-white" data-id="element-412">Tu piel no espera.</p>
            <p data-id="element-413">
              Cada semana sin el cuidado correcto es una semana más de colágeno
              perdido, manchas que se profundizan, poros que se congestionan.
            </p>
            <p data-id="element-414">
              Los cupos en Skin Glow Studio 22 son limitados — María Fernanda
              trabaja con atención personalizada e individualizada, lo que
              significa que no hay espacio para todos al mismo tiempo.
            </p>
            <p className="font-medium text-white" data-id="element-415">
              Las citas disponibles se llenan rápido.
            </p>
          </div>

          <div className="inline-block border border-brand-gold/50 bg-brand-charcoal/10 backdrop-blur-sm px-8 py-4 rounded-xl" data-id="element-416">
            <p className="text-brand-cream font-medium tracking-wide" data-id="element-417">
              No dejes que otra semana pase sin hacer algo real por tu piel.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
};